import { render, staticRenderFns } from "./TruckLoader.vue?vue&type=template&id=a698cc56&scoped=true"
import script from "./TruckLoader.vue?vue&type=script&lang=ts"
export * from "./TruckLoader.vue?vue&type=script&lang=ts"
import style0 from "./TruckLoader.vue?vue&type=style&index=0&id=a698cc56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a698cc56",
  null
  
)

export default component.exports